var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2716 3.25363C11.2715 3.2538 11.2718 3.25347 11.2716 3.25363L2.65836 11.7792C2.35764 12.0769 1.88294 12.0635 1.59809 11.7492C1.31323 11.435 1.32609 10.939 1.6268 10.6413L10.2421 2.11373C11.2168 1.15252 12.7869 1.15252 13.7616 2.11373L13.7626 2.11472L22.3769 10.6413C22.6776 10.939 22.6905 11.435 22.4056 11.7492C22.1208 12.0635 21.6461 12.0769 21.3454 11.7792L12.7321 3.25363C12.732 3.25352 12.7322 3.25375 12.7321 3.25363C12.3355 2.86292 11.6683 2.86302 11.2716 3.25363Z",
    fill: "#67C2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.1806C7.5 13.8047 7.86162 13.5 8.30769 13.5H15.6923C16.1384 13.5 16.5 13.8047 16.5 14.1806V18.0694C16.5 18.4453 16.1384 18.75 15.6923 18.75H8.30769C7.86162 18.75 7.5 18.4453 7.5 18.0694V14.1806ZM9.11538 14.8611V17.3889H14.8846V14.8611H9.11538Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48684 22.5C4.53158 22.5 3.75 21.6773 3.75 20.6718H3.75434V13.8159C3.75434 12.8104 4.31882 11.421 5.01355 10.7308L10.7408 5.01762C11.4355 4.32746 12.5688 4.32746 13.2636 5.01762L18.9908 10.7308C19.6812 11.421 20.25 12.8104 20.25 13.8159V20.6718C20.25 21.6773 19.4684 22.5 18.5132 22.5H5.48684ZM6.60088 21.0683C5.80902 21.0683 5.16113 20.4102 5.16113 19.606H5.16473V14.1224C5.16473 13.3181 5.63265 12.2067 6.20855 11.6547L10.9561 7.08503C11.532 6.53302 12.4715 6.53302 13.0474 7.08503L17.7949 11.6547C18.3672 12.2067 18.8388 13.3181 18.8388 14.1224V19.606C18.8388 20.4102 18.1909 21.0683 17.399 21.0683H6.60088Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.8f2fea56f83739e91ba94eb3e8cce89b.svg";
export { ForwardRef as ReactComponent };